import { writable, get } from 'svelte/store';
import { loadSearch } from '../api/search.api';
import { createUrlParamsString, updateUrlParameter } from '../../../core/helpers/url.helper';
import { windowPushHistory } from '../../../core/helpers/window.helper';
export default class SearchService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        this._pager = writable({ page: 1, perPage: 10 });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._searchList = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this._active = writable(false);
        this.submitFromUrl();
    }
    submitTypeChange() {
        // Note: Intentionally using searchParameterFromUrl because searchString doesn't need to be set yet.
        const urlSearchString = this._dataProvider.searchParameterFromUrl;
        this.submitSearch(urlSearchString);
    }
    submitSearch(searchString = this._dataProvider.searchString) {
        if (searchString) {
            const params = {
                q: searchString,
                typ: this._dataProvider.type,
            };
            windowPushHistory(createUrlParamsString(params));
            this.setPage(1);
            this._active.set(true);
            this.loadSearchResults(searchString);
        }
    }
    goToPage(page) {
        windowPushHistory(updateUrlParameter("strana", page));
        const urlSearchString = this._dataProvider.searchParameterFromUrl;
        if (urlSearchString) {
            this.setPage(page);
            this.loadSearchResults(urlSearchString);
        }
    }
    changePageSize(pageSize) {
        windowPushHistory(updateUrlParameter("pocet", pageSize));
        this.setPageSize(pageSize);
        this.goToPage(1);
    }
    submitFromUrl() {
        this._dataProvider.type = this._dataProvider.typeParameterFromUrl;
        // Note: Set value to this._dataProvider.searchString causes unwanted whisperer fetch and WhispererList display.
        // this._dataProvider.searchString = this._dataProvider.searchParameterFromUrl
        this._dataProvider.searchString = '';
        const urlSearchString = this._dataProvider.searchParameterFromUrl;
        if (urlSearchString) {
            const urlPage = this._dataProvider.pageParameterFromUrl;
            if (urlPage)
                this.setPage(urlPage);
            const urlPageSize = this._dataProvider.pageSizeParameterFromUrl;
            if (urlPageSize)
                this.setPageSize(urlPageSize);
            this._active.set(true);
            this.loadSearchResults(urlSearchString);
        }
    }
    loadSearchResults(searchString) {
        if (!searchString)
            return;
        this._processing.set(true);
        const searchParams = {
            endpoint: this.dataProvider.endpoint,
            query: searchString,
            type: this.dataProvider.type,
            structureKeys: this.dataProvider.apiStructureKeys,
            showSiteUrl: this.dataProvider.showSiteUrl,
            groupId: this.dataProvider.groupId,
            pager: this.pager
        };
        loadSearch(searchParams)
            .then((response) => {
            this._searchList.set(response.results);
            this._pager.set(Object.assign(Object.assign({}, this.pager), { total: response.total }));
            this._total.set(response.total);
            this._error.set(false);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    setPage(page) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { page }));
    }
    setPageSize(perPage) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { perPage }));
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get searchListSubs() {
        return this._searchList;
    }
    get activeSubs() {
        return this._active;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get processingSubs() {
        return this._processing;
    }
    get pagerSubs() {
        return this._pager;
    }
    get pager() {
        return get(this._pager);
    }
}
